import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import moment from 'moment'
import { BehaviorSubject, interval, Subscription } from 'rxjs'
import { IPGComponent } from '../../layout/components/ipg/ipg.component'
import { HeaderComponent } from '../../layout/components/header/header.component'
import { RouterService } from '../../services/router.service'

@Component({
  selector: 'app-program-guide',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslateModule, IPGComponent, HeaderComponent],
  templateUrl: './program-guide.component.html',
  styleUrls: ['./program-guide.component.scss'],
})
export class ProgramGuideComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription()

  now = moment()
  time$ = new BehaviorSubject<string>(this.now.format('LT'))

  constructor(private routerService: RouterService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      interval(1000).subscribe(() => {
        this.time$.next(moment().format('LT'))
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  goToPreviousPage(): void {
    this.routerService.goToHome()
  }
}
